import Vue from 'vue';
import VueRouter from 'vue-router';
import Hotjar from '@hotjar/browser';

import InteractionContainer from '@/containers/Interaction/InteractionContainer';
import CustomerResultsContainer from '@/containers/Results/CustomerResultsContainer';

import IATContainer from '@/containers/Items/IATContainer';
import IUBHComplete from "@/containers/Results/IUBH/IUBHComplete";
import ESGResultsContainer from "@/containers/Results/ESG";
import PrivacyPolicyContainer from "@/containers/PrivacyPolicyContainer";

Vue.use(VueRouter);

const routes = [
  {
    path: '/i/:interactionInstanceToken',
    name: 'InteractionContainer',
    component: InteractionContainer,
    props: true,
  },
  {
    path: '/iat',
    name: 'IATContainer',
    component: IATContainer,
    props: true,
  },
  // TODO: these components do not work at the moment due to issues with fountains/repeated measurements
  // plus their result endpoints need to be implemented specifically to avoid using unauthorized /dimensions call
  // {
  //   path: '/i/iat/:interactionInstanceToken/:iatResultDimensionName/results',
  //   name: 'IATResultsContainer',
  //   component: IATResultsContainer,
  //   props: true,
  // },
  // {
  //   path: '/i/:interactionInstanceToken/seemytype/results/type',
  //   name: 'TypeResultFeedbackContainer',
  //   component: IUBHTypeResultFeedbackContainer,
  //   props: true,
  // },
  // {
  //   path: '/i/:interactionInstanceToken/seemytype/results/iat',
  //   name: 'IUBHIATResultFeedbackContainer',
  //   component: IUBHIATResultFeedbackContainer,
  //   props: true,
  // },
  {
    path: '/i/:interactionInstanceToken/seemytype/complete',
    name: 'IUBHComplete',
    component: IUBHComplete,
    props: true,
  },
  {
    path: '/i/:interactionInstanceToken/results',
    name: 'CustomerResultsContainer',
    component: CustomerResultsContainer,
    props: true,
  },
  {
    path: '/i/:interactionInstanceToken/esg',
    name: 'ESGResultsContainer',
    component: ESGResultsContainer,
    props: true,
  },
  {
    path: '/i/:interactionInstanceToken/privacy-policy',
    name: 'PrivacyPolicyContainer',
    component: PrivacyPolicyContainer,
    props: true,
  },
  {
    path: '/i/*',
    name: 'PageNotFound',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../containers/PageNotFoundContainer'),
  },
];

const router = new VueRouter({
  mode: 'history',
  routes,
});


router.beforeEach((to, from, next) => {
  Hotjar.stateChange(to.path);
  next();
})

export default router;
